<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('schedule.scheduleInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="orderForm"
              :model="schedule"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('schedule.title')">
                      {{ schedule.title }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('schedule.type')">
                      {{ schedule.type }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.customers')">
                      {{ schedule.customerName
                      }}<small v-if="schedule.customerPhone != null"
                        >({{ schedule.customerPhone }})</small
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('schedule.planAt')">
                      {{ schedule.planAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">
                      {{ schedule.ownerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('schedule.state')">
                      {{ $t("scheduleStates." + schedule.workflowState) }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.sources')">
                      {{ schedule.source }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('customer.sourceRemark')">
                      {{ schedule.sourceRemark }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('customer.suggestName')"
                      v-if="schedule.suggestId != null"
                    >
                      {{ schedule.suggestName }}
                      <small>({{ schedule.suggestPhone }})</small>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15" v-if="schedule.fit == true">
                <legend>{{ $t("schedule.fit") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.time')">
                      {{ schedule.fitStartTime }}~{{ schedule.fitEndTime }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('schedule.fitName')">
                      {{ schedule.fitName }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15" v-if="schedule.makeup == true">
                <legend>{{ $t("schedule.makeup") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.time')">
                      {{ schedule.makeupStartTime }}~{{
                        schedule.makeupEndTime
                      }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="schedule.makeupName != null">
                    <el-form-item :label="$t('schedule.makeupName')">
                      {{ schedule.makeupName }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="schedule.content"></raw-html>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('customer.follow')" name="follow">
          <div class="drawer-content with-tab-footer">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="follow in follows"
                  :key="follow.id"
                  :timestamp="follow.createdAt"
                >
                  <span
                    v-if="follow.ownerName != null"
                    style="color: #909399"
                    >{{ follow.ownerName }}</span
                  >
                  <raw-html :content="follow.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="activeName == 'follow'"
        type="success"
        plain
        size="small"
        @click="addFollow"
        >+ {{ $t("customer.follows") }}</el-button
      >
    </div>

    <!-- 添加跟踪 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('customer.follow')"
      :close-on-click-modal="false"
      :visible.sync="addFollowDF"
      width="30%"
    >
      <el-form ref="addFollowForm" :model="addFollowObj">
        <el-form-item
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addFollowObj.content"
            :placeholder="$t('text.content')"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addFollowSubmitDoing"
          size="small"
          @click="addFollowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addFollowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Schedule from "@/api/schedule.js";
import Log from "@/api/log.js";
import ScheduleFollow from "@/api/scheduleFollow.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
  },
  data() {
    return {
      activeName: "detail",
      schedule: { title: null },
      logs: [],
      follows: [],
      // 新增跟踪
      addFollowDF: false,
      addFollowObj: { content: null, scheduleId: null },
      addFollowSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    // 新增跟踪
    addFollow() {
      this.addFollowObj.content = null;
      this.addFollowObj.scheduleId = this.id;
      this.addFollowSubmitDoing = false;
      this.addFollowDF = true;
    },
    addFollowSubmit() {
      const self = this;
      this.$refs.addFollowForm.validate((valid) => {
        if (valid) {
          console.log("===", this.addFollowObj);
          self.addFollowSubmitDoing = true;
          ScheduleFollow.create(this.addFollowObj).then(function (res) {
            self.addFollowSubmitDoing = false;
            self.addFollowDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getFollows();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getSchedule();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
      if (this.activeName == "follow") {
        this.getFollows();
      }
    },
    getSchedule() {
      const self = this;
      self.loadingStart();
      Schedule.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.schedule = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    getLogs(id) {
      const self = this;
      Log.forEntity("Schedule", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
    getFollows() {
      const self = this;
      ScheduleFollow.findByScheduleId(self.id).then(function (res) {
        if (res.status === 200) {
          self.follows = res.data;
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>